// extracted by mini-css-extract-plugin
module.exports = {"root":"SortPriceType_root__d5zuK","title":"SortPriceType_title__Dc1Sc","select":"SortPriceType_select__3_pkP"};